import DistancingHomeMain from "./DistancingHomeMain";
import DistancingHomeTopBar from "./DistancingHomeTopBar";

export default { Main: DistancingHomeMain, TopBar: DistancingHomeTopBar };
